export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      if (
        err?.response?.status === 401 &&
        err?.response?.data?.code === "UNAUTHORIZED"
      ) {
        window.location = "/logout";
      } else return Promise.reject(err);
    }
  );
}
